module.exports = __webpack_public_path__ + "puwendefault.jpg?f8f4f5c5203e82d59637d95c579e7349";